export default __webpack_public_path__ + "static/media/1.7daff6e1.jpg";